if (!customElements.get('cart-drawer-item')) {
  class CartDrawerItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addCartDrawerItemListeners();
    }

    addCartDrawerItemListeners() {
      const variantSelectEl = this.querySelector('.js-select-variant');
      if (variantSelectEl) variantSelectEl.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
      const selectedVariantId = event.target.value;
      const maxQuantity = Number(event.target.querySelector(`[value="${ selectedVariantId }`)?.dataset.maxQuantity);

      if (this.dataset.itemVariantId !== selectedVariantId) {
        this.replaceItemVariant(selectedVariantId, maxQuantity);
      }
    }

    replaceItemVariant(variantId, maxQuantity) {
      const itemQuantity = Number(this.closest('cart-drawer')?.querySelector('cart-quantity input[data-cart-quantity-input]')?.value);
      const updates = {
        [variantId]: itemQuantity ? (itemQuantity > maxQuantity ? maxQuantity : itemQuantity) : 1,
        [this.dataset.itemKey]: 0
      };

      this.setLoadingState();

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates, sections: "cart-drawer" })
      })
        .then(response => {
          if (!response.ok) throw new Error(`Network response was not ok for ${window.Shopify.routes.root + 'cart/update.js'}`);
          return response.json();
        })
        .then(data => {
          const newItemVariant = data.items_changelog.added[0].variant_id;
          
          this.querySelector('cart-quantity').updateCartCountIndicator();
          this.updateVariantData(newItemVariant, data.sections["cart-drawer"]);
        })
        .catch((error) => {
          console.error('Error:', error);
        }).finally(() => {
          this.hideLoadingState();
        });
    }

    updateCartInfo(markup) {
      document.querySelectorAll("[data-change-variant-update]").forEach((element) => {
        const selector = `[data-change-variant-update="${element.dataset.changeVariantUpdate}"]`;
        const updatedContent = markup.querySelector(selector)?.innerHTML;

        if (updatedContent) element.innerHTML = updatedContent;
      });
    }
    
    setLoadingState() {
      this.classList.add('is-loading');
    }

    hideLoadingState() {
      this.classList.remove('is-loading');
    }

    updateVariantData(newItemVariant, newMarkup) {
      const parser = new DOMParser();
      const newCartDrawerMarkup = parser.parseFromString(newMarkup, 'text/html');
      const newItemMarkup = newCartDrawerMarkup.querySelector(`cart-drawer-item[data-item-variant-id="${newItemVariant}"]`);

      if (newItemMarkup) this.replaceWith(newItemMarkup);
      this.updateCartInfo(newCartDrawerMarkup);
    }
  }

  customElements.define('cart-drawer-item', CartDrawerItem);
}
